import Mock from 'mockjs';

Mock.mock(/\/get\/i18n_type/, () => {
  return {
    code: 'success',
    data: {
      type: 'zh'
    },
    msg: 'ok'
  }
});



// WEBPACK FOOTER //
// ./src/mock/index.js